// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=text][data-v-0369aa16]:disabled,\ninput[type=number][data-v-0369aa16]:disabled {\n  background-color: #efefef;\n}\ninput[type=text][data-v-0369aa16] {\n  max-width: 120px;\n}", ""]);
// Exports
module.exports = exports;
